import React from 'react'
import PageWithSeo from 'features/page-with-seo'
import { Section } from 'layouts'
import { findSectionByIdentifier } from 'lib/pages/api'
import { PageType } from 'models/types/ts'
import PageBySlugQuery from 'queries/page-by-slug'
import { useSelector, useDispatch } from 'react-redux'
import { GlobalState } from 'types'
import { NOT_FOUND } from 'redux-first-router'
import { useTranslations } from './translations'
import { Hero, PastEvents, CurrentEvents } from './components'

const PlexForGood = (): JSX.Element => {
    const language = useSelector((state: GlobalState) => state.language)
    const dispatch = useDispatch()
    const slug = 'plex-for-good'

    // Use our custom hook to fetch translations
    const { translations } = useTranslations('PlexForGood')

    return (
        <PageBySlugQuery slug={slug} locale={language}>
            {(page: PageType) => {
                if (page) {
                    const sections = page?.sectionsCollection?.items

                    const fallbackBackground =
                        'https://images.ctfassets.net/7lhcm73ukv5p/2gCNmVCh4xuxQApftg46jE/4787b41fa6ff9bd3a7535ae87b504323/fanfest-hero-22.jpg'
                    const getPageBackground = (): string =>
                        page?.pageBackground
                            ? page.pageBackground.url
                            : fallbackBackground

                    const hero = findSectionByIdentifier(
                        sections,
                        'plex-for-good-hero'
                    )

                    const currentEvent = findSectionByIdentifier(
                        sections,
                        'plex-for-good-current-event'
                    )

                    const everGreen = findSectionByIdentifier(
                        sections,
                        'plex-for-good-ever-green'
                    )

                    const pastEvents = findSectionByIdentifier(
                        sections,
                        'plex-for-good-past-events'
                    )

                    return (
                        <PageWithSeo
                            page={page}
                            showLoading={false}
                            hideSitename={false}
                        >
                            <div>
                                <div>
                                    {hero && (
                                        <Section>
                                            <Hero section={hero} />
                                        </Section>
                                    )}
                                    {(currentEvent || everGreen) && (
                                        <Section>
                                            <CurrentEvents
                                                event={currentEvent}
                                                everGreen={everGreen}
                                                translations={translations}
                                            />
                                        </Section>
                                    )}
                                    {pastEvents && (
                                        <Section>
                                            <PastEvents events={pastEvents} />
                                        </Section>
                                    )}
                                </div>
                            </div>
                        </PageWithSeo>
                    )
                }

                // page not found in contentful
                dispatch({ type: NOT_FOUND })
                return <></>
            }}
        </PageBySlugQuery>
    )
}

export default PlexForGood
